<template>
  <ChatMessageTemplateModalStructure
    :loading="loading"
    :noTemplate="selectedTemplate == null"
  >
    <template #header>
      <ChatMessageTemplateHeader @close="emit('close')">
        テンプレートの編集
      </ChatMessageTemplateHeader>
    </template>

    <template #detail>
      <ChatMessageTemplateEditor
        v-if="form != null"
        v-model="form"
        @save="handleSave"
        @cancel="emit('changeMode', 'view')"
      />
    </template>
  </ChatMessageTemplateModalStructure>
</template>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue'

import ChatMessageTemplateHeader from './ChatMessageTemplateHeader.vue'
import ChatMessageTemplateEditor from './ChatMessageTemplateEditor.vue'
import ChatMessageTemplateModalStructure from './ChatMessageTemplateModalStructure.vue'
import {
  useChatMessageTemplate,
  cloneChatTemplate,
} from './useChatMessageTemplate'

import { useAlert } from '@/libs/alertPortal'
import { isDefinedRef } from '@/libs/utilities/isDefinedRef'

import type { ChatMessageTemplate } from '@/types/app'
import type { ChatMessageTemplateModalMode } from './types'

const props = defineProps<{
  selectedGuid: Maybe<ChatMessageTemplate['guid']>
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'changeMode', value: ChatMessageTemplateModalMode): void
}>()

const form = ref<Maybe<ChatMessageTemplate>>()

const { loading, map, updateTemplate } = useChatMessageTemplate()
const selectedTemplate = computed(() =>
  props.selectedGuid != null ? map.value.get(props.selectedGuid) : null
)

watch(
  selectedTemplate,
  selected => {
    if (selected == null) {
      return
    }
    form.value = cloneChatTemplate(selected)
  },
  { immediate: true }
)

const clearForm = () => {
  form.value = undefined
}

const alert = useAlert()
const handleSave = async () => {
  if (!isDefinedRef(form)) {
    return
  }
  const normalizedData = {
    ...cloneChatTemplate(form.value),
    selections: form.value.selections.filter(item => item !== ''),
  }
  await updateTemplate(normalizedData)
  alert.success(`テンプレート「${normalizedData.label}」を保存しました`)
  clearForm()
  emit('changeMode', 'view')
}
</script>
